import { Deserializable } from '../protocols/deserializable';
import { TransactionEntryLegacyCodeType } from './transaction-entry-legacy-code-type';
import { FundType } from './fund-type';
import * as moment from 'moment';
import { Account } from './account';

export class TransactionEntry implements Deserializable {
  public id!: string;
  public transactionId!: number;
  public accountId!: number;
  public fundId!: number;
  public fund!: FundType;
  public codeId!: number;
  public codeName!: string;
  public codeIdAndName!: string;
  public isDebit!: boolean;
  public legacyCodeId!: number | null;
  public legacyCode!: TransactionEntryLegacyCodeType | null;
  public debitedUnitCount!: number | null;
  public creditedUnitCount!: number | null;
  public unitSettlementPrice!: number;
  public settledDebitValue!: number | null;
  public settledCreditValue!: number | null;
  public createdDate: string | null = null;
  public postedDate: string | null = null;
  public account: Account | null = null;
  public transactionTypeId!: number;
  public transactionTypeName!: string;

  // Not from API
  public formattedPostedDate: string | null = null;

  onDeserialize() {
    if (this.account) {
      this.account = window?.injector?.Deserialize.instanceOf(Account, this.account);
    }
    if (this.legacyCode) {
      this.legacyCode = window?.injector?.Deserialize.instanceOf(TransactionEntryLegacyCodeType, this.legacyCode);
    }
    if (this.fund) {
      this.fund = window?.injector?.Deserialize.instanceOf(FundType, this.fund);
    }
    if (this.postedDate) {
      this.formattedPostedDate = moment.utc(this.postedDate).format('MMM D, YYYY');
    }
  }
}
